// @flow

import React, { Fragment } from 'react'
import $ from 'jquery'
import { HashLink as Link } from 'react-router-hash-link';
import { withRouter } from "react-router";
import { connect } from 'react-redux'
import bindAll from 'lodash/bindAll'
import initializers from '../../dependencies/initializers'

import { accesslog, translate } from '../../helpers/global'
import AstrntLogo from '../../styles/img/astro-logo.svg?v=1'

import Cookies from 'js-cookie';
import { usersGetDetailAsync } from '../../actions/users.js'

import { UilSearch, UilTimes } from '@iconscout/react-unicons'
import DropdownTalentAcqMobile from './DropdownTalentAcqMobile'
import DropdownTalentMgMobile from './DropdownTalentMgMobile'
import DropdownUniMobile from './DropdownUniMobile'
import DropdownTalentAcq from './DropdownTalentAcq'
import DropdownTalentMg from './DropdownTalentMg'
import DropdownUni from './DropdownUni'
import ModalTalkExpert from './ModalTalkExpert'


type Props = {
	isNavbarFixed: boolean
};

class HeaderNewClear extends React.Component<Props> {
	constructor(props) {
		super(props)
		this.state = {
		menu: false,
		activeDropdown: null,  // Track which dropdown is active
		isModalTalkOpen: false,
		searchValue: '',
		};
		this.langContainRef = React.createRef();
		this.talentAcqContainRef = React.createRef();
		this.talentMgContainRef = React.createRef();
		this.uniContainRef = React.createRef();
		this.accContainRef = React.createRef();
		this.techContainRef = React.createRef();

		bindAll(this, [
			'handleRegisterLink',
			'toggleMenu',
			'detectClick',
			'showDropdownOnHover',
			'hideDropdownOnLeave',
			'handleSearchInputChange',
			'handleSearchClear',
			'handleSearchSubmit',
			'handleCategoryNavigate',
			'handleLearnNavigation',
			'closeDropdown'
		])
	}

	// Define the routes that should activate each dropdown
	talentAcquisitionRoutes = [
		'/talent-acquisition/astrnt-platform/ai-structured-video-interview',
		'/talent-acquisition/skill-validation',
		'/talent-acquisition/assessments',
		'/apis',
		'/nextgen-assessment-center',
		'/nextgen-rpo',
		'/graduate',
		'/professional',
		'/talent-acquisition/professional',
        '/talent-acquisition/technical',
        '/talent-acquisition/hourly'

	];

	talentManagementRoutes = [
		// Add your talent management routes here
		'/talent-management/performance',
		'/talent-management/development',
		'/talent-management/internal-mobility',
        '/talent-management/talent-mapping',
        '/talent-management/succession-planning',
        '/talent-management/high-potential-identification'
		// etc.
	];

	universityRoutes = [
		// Add your university routes here
		'/admissions',
		'/career-center'
		// etc.
	];

	learnRoutes = [
		'/learn',
		'/learn-detail'
	];

	// Method to check if current route matches talent acquisition paths
	isCurrentRouteInTalentAcquisition() {
		const currentPath = this.props.location.pathname;
		const urlParams = new URLSearchParams(this.props.location.search);
		
		// Check for the shared route with specific parameter or no parameter (default)
		if (currentPath === '/nextgen-assessment-center') {
			const fromParam = urlParams.get('utm_content');
			return fromParam === 'talent-acquisition' || !fromParam; // Default to talent-acquisition if no param
		}
		
		return this.talentAcquisitionRoutes.some(route => currentPath.includes(route));
	}

	// Method to check if current route matches talent management paths
	isCurrentRouteInTalentManagement() {
		const currentPath = this.props.location.pathname;
		const urlParams = new URLSearchParams(this.props.location.search);
		
		// Check for the shared route with specific parameter
		if (currentPath === '/nextgen-assessment-center') {
			return urlParams.get('utm_content') === 'talent-management';
		}
		
		return this.talentManagementRoutes.some(route => currentPath.includes(route));
	}

	// Method to check if current route matches university paths
	isCurrentRouteInUniversity() {
		const currentPath = this.props.location.pathname;
		return this.universityRoutes.some(route => currentPath.includes(route));
	}

	// Method to check if current route matches learn paths
	isCurrentRouteInLearn() {
		const currentPath = this.props.location.pathname;
		return this.learnRoutes.some(route => currentPath.includes(route));
	}

	toggleMenu(){
    this.setState({ menu: !this.state.menu })
  }	

	handleLoginLink(e: Object): void {
		e.preventDefault()
			window.location = initializers.recruiter_host+'/auth/login'
	}

	handleRegisterLink(e: Object): void {
		e.preventDefault()
		const{
			history
		}=this.props
		
		history.push('/register')
	}

	showDropdownAccount() {
		if ($('#account-drop').hasClass('hide')) {
			$('#account-drop').removeClass('hide')
			$('#home-drop').addClass('hide')
			$('.drop-btn-account-mobile').addClass('is-open')
		} else {
			$('#account-drop').addClass('hide')
			$('.drop-btn-account-mobile').removeClass('is-open')
		}
	}

	showDropdown() {
		if ($('#home-drop').hasClass('hide')) {
			$('#home-drop').removeClass('hide')
			$('.drop-btn-lang').addClass('is-open')
			$('#account-drop').addClass('hide')
		} else {
			$('#home-drop').addClass('hide')
			$('.drop-btn-lang').removeClass('is-open')
		}
	}

	// New methods for hover functionality
	showDropdownOnHover() {
		$('#home-drop').removeClass('hide')
		$('.drop-btn-tech').addClass('is-open')
	}

	hideDropdownOnLeave() {
		$('#home-drop').addClass('hide')
		$('.drop-btn-tech').removeClass('is-open')
	}

	// Separate dropdown functions for mobile
	showDropdownTalentAcq() {
		if ($('#talent-acq-drop').hasClass('hide')) {
			$('#talent-acq-drop').removeClass('hide')
			$('#talent-mg-drop').addClass('hide')
			$('#uni-drop').addClass('hide')
			$('#id-a-talent-acq').addClass('is-open')
			$('#id-a-talent-mg').removeClass('is-open')
			$('#id-a-uni').removeClass('is-open')
		} else {
			$('#talent-acq-drop').addClass('hide')
			$('#id-a-talent-acq').removeClass('is-open')
		}
	}

	showDropdownTalentMg() {
		if ($('#talent-mg-drop').hasClass('hide')) {
			$('#talent-mg-drop').removeClass('hide')
			$('#talent-acq-drop').addClass('hide')
			$('#uni-drop').addClass('hide')
			$('#id-a-talent-mg').addClass('is-open')
			$('#id-a-talent-acq').removeClass('is-open')
			$('#id-a-uni').removeClass('is-open')
		} else {
			$('#talent-mg-drop').addClass('hide')
			$('#id-a-talent-mg').removeClass('is-open')
		}
	}

	showDropdownUni() {
		if ($('#uni-drop').hasClass('hide')) {
			$('#uni-drop').removeClass('hide')
			$('#talent-acq-drop').addClass('hide')
			$('#talent-mg-drop').addClass('hide')
			$('#id-a-uni').addClass('is-open')
			$('#id-a-talent-acq').removeClass('is-open')
			$('#id-a-talent-mg').removeClass('is-open')
		} else {
			$('#uni-drop').addClass('hide')
			$('#id-a-uni').removeClass('is-open')
		}
	}

	showDropdownTech() {
		if ($('#tech-drop').hasClass('hide')) {
			$('#tech-drop').removeClass('hide')
			$('.drop-btn-tech').addClass('is-open')
			$('#account-drop').addClass('hide')
			$('#talent-acq-drop').addClass('hide')
			$('#talent-mg-drop').addClass('hide')
			$('#uni-drop').addClass('hide')
			$('#id-a-talent-acq').removeClass('is-open')
			$('#id-a-talent-mg').removeClass('is-open')
			$('#id-a-uni').removeClass('is-open')
			$('header ul.for-nav').slideUp('fast');
			$('.overlay-header').fadeOut('fast');
		} else {
			$('#tech-drop').addClass('hide')
			$('.drop-btn-tech').removeClass('is-open')
		}
	}

	// New method to handle desktop dropdown clicks
	handleDesktopDropdown(dropdownType, event) {
		event.preventDefault();

		// Disable search dropdown when on learn-search page
		if (dropdownType === 'search' && this.props.location.pathname === '/learn-search') {
			return;
		}

		const isCurrentlyOpen = this.state.activeDropdown === dropdownType;

		if (!isCurrentlyOpen) {
			// Close current dropdown
			this.closeForNav(() => {
				// After close, open new dropdown
				this.setState({ activeDropdown: dropdownType }, () => {
					$(event.target).closest('a').addClass('is-open');
					$('header ul.for-nav').slideDown(100);
					$('.overlay-header').fadeIn(100);
				});
			});
		} else {
			// Close current dropdown
			this.closeForNav();
		}
	}

	closeForNav(callback) {
		// Remove is-open class from all dropdown buttons
		$('header .dropdown-desktop-button').removeClass('is-open');
		$('header ul.main-nav li a.is-open').removeClass('is-open');
		$('header a.on-before').removeClass('on-before');

		// Animate close and wait
		const navPromise = $('header ul.for-nav').slideUp(100).promise();
		const overlayPromise = $('.overlay-header').fadeOut(100).promise();

		$.when(navPromise, overlayPromise).done(() => {
			this.setState({ activeDropdown: null }, () => {
				if (typeof callback === 'function') {
					callback();
				}
			});
		});
	}

	// Method to close dropdown that can be passed to dropdown components
	closeDropdown() {
		this.closeForNav();
		// Also close mobile dropdowns
		$('#talent-acq-drop').addClass('hide');
		$('#talent-mg-drop').addClass('hide');
		$('#uni-drop').addClass('hide');
		$('#id-a-talent-acq').removeClass('is-open');
		$('#id-a-talent-mg').removeClass('is-open');
		$('#id-a-uni').removeClass('is-open');
	}

	chooseOpt(val) {
	const url_api = initializers.api_host
	  if(val == 'logout') {
		Cookies.remove('astrnt_user_company');
		Cookies.remove('astrnt_user_email');
		Cookies.remove('astrnt_user_name');
		Cookies.remove('astrnt_user_phone');
		this.props.usersGetDetailAsync({})
		window.location = (url_api + '/auth/logout')
	  } else if(val === 'dashboard') {
	  	window.location = (url_api)
	  } else if(val === '1') {
	  	if (process.env.NODE_ENV === 'development') {
			window.location = 'http://localhost:3000/'
		} else if (url_api == 'https://beta.astrnt.co') {

			window.location = 'https://test.astrnt.co/'

		} else {
			window.location = 'https://astrnt.co/'
		}
	  } else {
	  	if (process.env.NODE_ENV === 'development') {
			window.location = 'http://localhost:3000/'
		} else if (url_api == 'https://beta.astrnt.co') {

			window.location = 'https://test.astrnt.id/'

		} else {
			window.location = 'https://astrnt.id/'
		}
	  }
	}

	 handleCloseModalTalk = () => {
		this.setState({ isModalTalkOpen: false });
	};

	// Search functionality methods
	handleSearchInputChange = (e) => {
		this.setState({ searchValue: e.target.value });
	}

	handleSearchClear = () => {
		this.setState({ searchValue: '' });
	}

	handleSearchSubmit = () => {
		if (this.state.searchValue.trim()) {
			// Navigate to search page with query parameter
			this.props.history.push(`/learn-search?q=${encodeURIComponent(this.state.searchValue.trim())}`);
			// Close the search dropdown
			this.closeForNav();
		}
	}

	handleCategoryNavigate = (category) => {
		// Hide the dropdown
		this.hideDropdownOnLeave();
		localStorage.setItem('fromHeaderNavigation', 'true');
		
		// Check if we're already on the learn page
		if (this.props.location.pathname === '/learn') {
			// If we're already on the learn page, dispatch a custom event
			// that the Learn component can listen to
			const event = new CustomEvent('learnCategoryFilter', { 
				detail: { category: category } 
			});
			window.dispatchEvent(event);
		} else {
			// Store the category in localStorage for navigation to learn page
			localStorage.setItem('selectedLearnCategory', category);
			localStorage.setItem('fromHeaderNavigation', 'true');
			// Navigate to learn page
			this.props.history.push('/learn');
		}
	}

	handleLearnNavigation = () => {
		// Set header navigation flag to false (don't hide banner for main Learn button)
		localStorage.setItem('fromHeaderNavigation', 'false');
		
		// Check if we're already on the learn page
		if (this.props.location.pathname === '/learn') {
			// If we're already on the learn page, dispatch a custom event to reset filters
			const event = new CustomEvent('learnCategoryFilter', { 
				detail: { category: null } // null means show all posts
			});
			window.dispatchEvent(event);
		} else {
			// Clear any existing category filter for navigation to learn page
			localStorage.removeItem('selectedLearnCategory');
		}
	}

	componentDidMount() {
		const {globalGetLanguages} = this.props

		if(Cookies.get('astrnt_user_company')) {
			this.props.usersGetDetailAsync({
				company: Cookies.get('astrnt_user_company'),
				email: Cookies.get('astrnt_user_email'),
				name: Cookies.get('astrnt_user_name'),
				phone: Cookies.get('astrnt_user_phone')
			})
		}

	    if (globalGetLanguages == 'id') {
	    	$('.btn-lang-en').addClass('hide')
	    	$('.btn-lang-id').removeClass('hide')
	    } else {
	    	$('.btn-lang-en').removeClass('hide')
	    	$('.btn-lang-id').addClass('hide')
	    }

	    // Check current route and add is-page-open class to appropriate dropdown buttons
	    if (this.isCurrentRouteInTalentAcquisition()) {
	    	$('.dropdown-desktop-button[data-dropdown="talent-acquisition"]').addClass('is-page-open');
	    } else if (this.isCurrentRouteInTalentManagement()) {
	    	$('.dropdown-desktop-button[data-dropdown="talent-management"]').addClass('is-page-open');
	    } else if (this.isCurrentRouteInUniversity()) {
	    	$('.dropdown-desktop-button[data-dropdown="university"]').addClass('is-page-open');
	    }

	    // Add active state for Learn dropdown when on learn pages
	    if (this.isCurrentRouteInLearn()) {
	    	$('.drop-btn-tech').addClass('is-page-open');
	    }
	    
	    $('header a.nav-mob').click(function(event){
	        event.preventDefault();
	        
	        if($('header ul.main-nav').is(':hidden')){
	            $(this).find('i').fadeOut('fast', function(){
	                $(this).attr('class', 'fas fa-times').fadeIn('fast');
	            });
	            $('header ul.main-nav').slideDown('fast');
	        }else{
	            $(this).find('i').fadeOut('fast', function(){
	                $(this).attr('class', 'fas fa-bars').fadeIn('fast');
	            });
	            $('header ul.main-nav').slideUp('fast');
	            this.closeForNav();
	        }
	    }.bind(this));
	    
	    $('.overlay-header').click(() => {
	        this.closeForNav();
	    });

	    $('.dropdown-for > div > a.a-for').click(function(event){
        event.preventDefault();
        
        if(!$(this).hasClass('is-on')){
            $(this).addClass('is-on').parent().find('div').slideDown('fast');
        }else{
            $(this).removeClass('is-on').parent().find('div').slideUp('fast');
        }
    	});

		window.addEventListener("click", this.detectClick)
	}

	componentDidUpdate(prevProps) {
		// Check if route has changed
		if (prevProps.location.pathname !== this.props.location.pathname) {
			// Remove is-open class from all dropdown buttons first
			$('.dropdown-desktop-button').removeClass('is-open');
			$('.drop-btn-tech').removeClass('is-page-open');
			
			// Then add it to the appropriate one based on current route
			if (this.isCurrentRouteInTalentAcquisition()) {
				$('.dropdown-desktop-button[data-dropdown="talent-acquisition"]').addClass('is-open');
			} else if (this.isCurrentRouteInTalentManagement()) {
				$('.dropdown-desktop-button[data-dropdown="talent-management"]').addClass('is-open');
			} else if (this.isCurrentRouteInUniversity()) {
				$('.dropdown-desktop-button[data-dropdown="university"]').addClass('is-open');
			}

			// Add active state for Learn dropdown when on learn pages
			if (this.isCurrentRouteInLearn()) {
				$('.drop-btn-tech').addClass('is-page-open');
			}
		}
	}

detectClick(event){
	if (this.langContainRef.current != null) {
		if (!this.langContainRef.current.contains(event.target)) {
			$('#home-drop').addClass('hide')
			$('.drop-btn-lang').removeClass('is-open')
		  }
	}
	if (this.talentAcqContainRef.current != null) {
		if (!this.talentAcqContainRef.current.contains(event.target)) {
			$('#talent-acq-drop').addClass('hide')
			$('#id-a-talent-acq').removeClass('is-open')
		  }
	}
	if (this.talentMgContainRef.current != null) {
		if (!this.talentMgContainRef.current.contains(event.target)) {
			$('#talent-mg-drop').addClass('hide')
			$('#id-a-talent-mg').removeClass('is-open')
		  }
	}
	if (this.uniContainRef.current != null) {
		if (!this.uniContainRef.current.contains(event.target)) {
			$('#uni-drop').addClass('hide')
			$('#id-a-uni').removeClass('is-open')
		  }
	}
	if (this.accContainRef.current != null) {
		if (!this.accContainRef.current.contains(event.target)) {
			$('#account-drop').addClass('hide')
			$('.drop-btn-account-mobile').removeClass('is-open')
		  }
	}
	if (this.techContainRef.current != null) {
		if (!this.techContainRef.current.contains(event.target)) {
			$('#tech-drop').addClass('hide')
			$('.drop-btn-tech').removeClass('is-open')
		  }
	}
}

// Render the appropriate dropdown component based on activeDropdown state
renderDropdownContent() {
	const { globalGetLanguages } = this.props;
	const { activeDropdown } = this.state;

	if (!activeDropdown) return null; // ⛔ don't render anything
	
	switch (this.state.activeDropdown) {
		case 'talent-acquisition':
			return <DropdownTalentAcq globalGetLanguages={globalGetLanguages} closeDropdown={this.closeDropdown} />;
		case 'talent-management':
			return <DropdownTalentMg globalGetLanguages={globalGetLanguages} closeDropdown={this.closeDropdown} />;
		case 'university':
			return <DropdownUni globalGetLanguages={globalGetLanguages} closeDropdown={this.closeDropdown} />;
		case 'search':
			return (
				<section>
					<div className="dropdown-search">
						<div className="search-container">
							<div className="search-input-container">
								<input 
									type="text" 
									placeholder="Search" 
									className="search-input"
									value={this.state.searchValue}
									onChange={this.handleSearchInputChange}
									onKeyPress={(e) => {
										if (e.key === 'Enter') {
											this.handleSearchSubmit();
										}
									}}
								/>
								{this.state.searchValue && (
									<button 
										className="search-clear-button" 
										onClick={this.handleSearchClear}
										type="button"
									>
										<UilTimes size="24" />
									</button>
								)}
							</div>
							<button 
								className="search-button" 
								disabled={!this.state.searchValue.trim()}
								onClick={this.handleSearchSubmit}
								type="button"
							>
								<UilSearch size="24" />
							</button>
						</div>
					</div>
				</section>
			);
		default:
			return null; // ⛔ fallback to nothing instead of default component
	}
}

  render() {
	const {
		globalGetLanguages,
		user
	} = this.props

	const renderHTML = (rawHTML: string) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });

	// Determine if any dropdown is open
 	const isDropdownOpen = this.state.activeDropdown !== null;
	
    return (
			<Fragment>
				<header className={`clear ${isDropdownOpen ? 'drop-open' : ''}`}>
					<div className="top-header">
					  <section>
						<Link to="/candidate-support">{renderHTML(translate(globalGetLanguages,'HEADER_CANDIDATES_INTERVIEWING'))}</Link>
					  </section>
					</div>
		          <section>
		            <Link to="/" className={`logo`}><img src={AstrntLogo} /></Link>
		            <a href="#" className="nav-mob"><i className="fas fa-bars" /></a>
		            <ul className="main-nav">
		            <li>
		            	<a href="#" 
		            	   className="dropdown-desktop-button desktop-hide-header"
		            	   data-dropdown="talent-acquisition"
		            	   onClick={(e) => this.handleDesktopDropdown('talent-acquisition', e)}>
		            	   Talent Acquisition <i className="fas fa-angle-down" />
		            	</a>
		              <li id="id-li-drop-talent-acq" className="mobile-hide-header" ref={this.talentAcqContainRef}>
		              	<a id="id-a-talent-acq" onClick={() => this.showDropdownTalentAcq()}>Talent Acquisition <i id="id-angle-down-talent-acq" className="fas fa-angle-down" /></a>
		              	<DropdownTalentAcqMobile globalGetLanguages={globalGetLanguages} />
	          	          </li>
		              </li>
					  <li>
		            	<a href="#" 
		            	   className="dropdown-desktop-button desktop-hide-header"
		            	   data-dropdown="talent-management"
		            	   onClick={(e) => this.handleDesktopDropdown('talent-management', e)}>
		            	   Talent Management <i className="fas fa-angle-down" />
		            	</a>
		              <li id="id-li-drop-talent-mg" className="mobile-hide-header" ref={this.talentMgContainRef}>
		              	<a id="id-a-talent-mg" onClick={() => this.showDropdownTalentMg()}>Talent Management <i id="id-angle-down-talent-mg" className="fas fa-angle-down" /></a>
		              	<DropdownTalentMgMobile globalGetLanguages={globalGetLanguages} />
	          	          </li>
		              </li>
					  <li className="header-li-univ">
		            	<a href="#" 
		            	   className="dropdown-desktop-button desktop-hide-header"
		            	   data-dropdown="university"
		            	   onClick={(e) => this.handleDesktopDropdown('university', e)}>
		            	   University <i className="fas fa-angle-down" />
		            	</a>
		              <li id="id-li-drop-uni" className="mobile-hide-header" ref={this.uniContainRef}>
		              	<a id="id-a-uni" onClick={() => this.showDropdownUni()}>University <i id="id-angle-down-uni" className="fas fa-angle-down" /></a>
		              	<DropdownUniMobile globalGetLanguages={globalGetLanguages} />
	          	          </li>
		              </li>
					  <li className=""><Link to={`/assessments-and-interviews`}>Assessments & Interviews</Link></li>
					  <li ref={this.techContainRef} 
					      onMouseEnter={() => this.showDropdownOnHover()} 
					      onMouseLeave={() => this.hideDropdownOnLeave()}>
	                	  <Link to="/learn" className="drop-btn-tech" onClick={this.handleLearnNavigation}>Learn<i id="id-angle-down" className="fas fa-angle-down" /></Link>
	                	  <div id="home-drop" className="dropdown-learn hide">
		                	  <Link to="/learn" onClick={() => this.handleCategoryNavigate('customer-story')}>Customer Stories</Link>
		                	  <Link to="/learn" onClick={() => this.handleCategoryNavigate('ai-and-talent')}>AI & Talent</Link>
		                	  <Link to="/learn" onClick={() => this.handleCategoryNavigate('product-and-updates')}>Product & Updates</Link>
	                	  </div>
		              </li>
					  <li className="hide"><Link to={`/assessments-and-interviews`}>{translate(globalGetLanguages,'HOMEPAGE_ASSESSMENTS')}</Link></li>
		              <li>
		            	<a href="#" 
		            	   className={`dropdown-desktop-button desktop-hide-header cursor-pointer ${this.state.activeDropdown === 'search' ? 'is-open' : ''} ${this.props.location.pathname === '/learn-search' ? 'disabled' : ''}`}
		            	   data-dropdown="search"
		            	   onClick={(e) => this.handleDesktopDropdown('search', e)}
		            	   style={this.props.location.pathname === '/learn-search' ? { opacity: 1, cursor: 'not-allowed' } : {}}>
		            	   <UilSearch size="20" />
		            	</a>
		              </li>
		              <li><a className="cursor-pointer" onClick={this.handleLoginLink}>{translate(globalGetLanguages,'LOGIN')}</a></li>
		              <li className="register-button"><Link to={{pathname: `/register`, query: { plan: 'free' }}}
					  	onClick={() => accesslog('header', 'button_register', {title: 'Start Your Free Plan'}) }
					  >{translate(globalGetLanguages,'HOMEPAGE_BUTTON_GET_ASTRNT_FOR_FREE')}</Link></li>
					  <li ref={this.accContainRef} className="hide">
						<a className="drop-btn-account desktop-flex-hide" onClick={() => this.showDropdownAccount()}>{user?.get('name')?.charAt(0) || "A"}</a>
						<a className="drop-btn-account-mobile mobile-hide-header" onClick={() => this.showDropdownAccount()}>My Account<i id="" className="fas fa-angle-down" style={{float: 'right',marginTop: '20px'}} /></a>
						<div id="account-drop" className="dropdown-account hide">
								<div id="id-account-info" className='flex-container'>
									<div className='account-icon'>{user?.get('name') ? user.get('name').charAt(0) : "A"}</div>
									<div className='account-info'>
										<label>{user.get('name')}</label>
										<span>{user.get('email')}</span>
									</div>
								</div>
								<hr className='desktop-hide-header'/>
								<div onClick={() => this.chooseOpt('dashboard')}>Go to Astronaut Dashboard</div>
								<hr className='desktop-hide-header'/>
								<div onClick={() => this.chooseOpt('logout')}>Log Out</div>
	                	  </div>
						</li>
		            </ul>
		          </section>
				  <div className="desktop-hide-header">
					<ul className="for-nav" style={{
							display: 'none',
							...(this.state.activeDropdown === 'search' && { background: 'white', padding: '0' })
						}}>
						{this.state.activeDropdown !== 'search' && <div className="white-box-header"></div>}
		          		{this.renderDropdownContent()}
					</ul>
				  </div>
		        </header>
		        <div className="overlay-header force-hide-mobile" style={{display: 'none'}} />
				<ModalTalkExpert isOpen={this.state.isModalTalkOpen} onClose={this.handleCloseModalTalk} />
		    </Fragment>
		)
  }
}

HeaderNewClear.defaultProps = {
	isNavbarFixed: true
}

const mapStateToProps = (state, ownProps) => {
	return {
		globalGetLanguages:state.globalGetLanguages,
		user: state.user
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		usersGetDetailAsync: (user) => dispatch(usersGetDetailAsync(user))
	}
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(HeaderNewClear))